<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('answers.title')" icon="briefcase">
            <app-default-button
                v-if="$can('create_answer')"
                :title="$addLabel('answer')"
                @click="openAnswerModal()"
            />
        </app-page-top-section>

        <app-table
            id="answer-table"
            :options="options"
            @action="triggerActions"
        />

        <app-answer-modal
            v-if="isAnswerModalActive"
            v-model="isAnswerModalActive"
            :selected-url="selectedUrl"
            />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('answer-table')"
            @cancelled="cancelled"
        />


    </div>
</template>

<script>
import AnswerMixin from "../../../Mixins/Learning/AnswerMixin";

export default {
    name: "Answers",
    mixins: [AnswerMixin],
    data() {
        return {
            answer: '',
            answersId: '',
            answers: [],
            selectedUrl: '',
            modalClass: '',
            promptIcon: '',
            promptSubtitle: '',
            question_id: '',
            answer_text: '',
            is_correct: '',
            isAnswerModalActive: false,
            confirmationModalActive: false,
        }
    },
    created() {
        this.$store.dispatch( 'answer')
    },
    watch: {
        isAnswerModalActive: function (value) {
            if (!value) {
                this.selectedUrl = '';
            }
        }
    },
    methods: {
        openAnswerModal() {
            this.selectedUrl = '';
            this.isAnswerModalActive = true;
        },
        triggerActions(row, action, active) {
            this.answersId = row.id;
            this.promptIcon = action.icon;
            this.modalClass = action.modalClass;
            this.promptSubtitle = action.promptSubtitle;

            if (action.name === 'edit') {
                this.selectedUrl = `${action.url}/${row.id}`;
                this.isAnswerModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        cancelled() {
            this.confirmationModalActive = false;
        },
    }
}
</script>
